import { useMutation } from "@tanstack/react-query";
import {
  createFuelTypesAPI,
  deleteFuelTypesAPI,
  updateFuelTypesAPI,
} from "./fuelTypes.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddFuelTypesMutation = () => {
  return useMutation({
    mutationFn: createFuelTypesAPI,
    onError: handleNetworkError,
  });
};

const useUpdateFuelTypesMutation = () => {
  return useMutation({
    mutationFn: updateFuelTypesAPI,
    onError: handleNetworkError,
  });
};

const useDeleteFuelTypesMutation = () => {
  return useMutation({
    mutationFn: deleteFuelTypesAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddFuelTypesMutation,
  useUpdateFuelTypesMutation,
  useDeleteFuelTypesMutation,
};
